import { WebGLRenderer, PCFSoftShadowMap, Matrix4, Vector3 } from 'three';
import { OverlayObject } from '../objects/OverlayObject';
/**
 * advanced rendering features for glow
 * especially for virtual reality
 */
export class Renderer extends WebGLRenderer {
    constructor(configuration) {
        super(configuration.getWebGLRendererParameters());
        this._vector = new Vector3();
        this._viewMatrix = new Matrix4();
        this._viewProjectionMatrix = new Matrix4();
        this._init(configuration);
    }
    setOverlayElement(parentElement) {
        this._olElement = document.createElement('div');
        this._olElement.style.overflow = 'hidden';
        this._olElement.style.display = 'contents';
        this._olElement.style.position = 'absolute';
        this._olElement.style.top = '0';
        this._olElement.style.bottom = '0';
        this._olElement.style.left = '0';
        this._olElement.style.right = '0';
        this._olElement.style.pointerEvents = 'none';
        parentElement.insertBefore(this._olElement, this.domElement);
    }
    /**
     * special handling for VR
     * @param func the real 'requestAnimationFrame' function
     */
    requestAnimationFrame(func) {
        if (this.vr.enabled) {
            const device = this.vr.getDevice();
            if (device && device.isPresenting) {
                device.requestAnimationFrame(func);
                return;
            }
        }
        window.requestAnimationFrame(func);
    }
    renderAdvanced(scene, camera) {
        this.render(scene, camera);
        if (this._overlays) {
            scene.updateMatrixWorld();
            if (camera.parent === null) {
                camera.updateMatrixWorld();
            }
            this._viewMatrix.copy(camera.matrixWorldInverse);
            this._viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, this._viewMatrix);
            this._renderOverlay(scene, camera);
        }
    }
    _renderOverlay(object, camera) {
        if (object instanceof OverlayObject) {
            const vector = this._vector;
            vector.setFromMatrixPosition(object.matrixWorld);
            vector.applyMatrix4(this._viewProjectionMatrix);
            const _widthHalf = this.domElement.width / 2;
            const _heightHalf = this.domElement.height / 2;
            const element = object.element;
            const style = 'translate(-50%,-50%) translate(' + (vector.x * _widthHalf + _widthHalf) + 'px,' + (-vector.y * _heightHalf + _heightHalf) + 'px)';
            element.style.webkitTransform = style;
            // element.style.mozTransform = style;
            // element.style.oTransform = style;
            element.style.transform = style;
            // element.style.display = ( object.visible && vector.z >= - 1 && vector.z <= 1 ) ? '' : 'none';
            /*const objectData = {
              distanceToCameraSquared: getDistanceToSquared( camera, object ),
            };*/
            // cache.objects.set( object, objectData );
            if (element.parentNode !== this._olElement) {
                this._olElement.appendChild(element);
            }
        }
        for (let i = 0, l = object.children.length; i < l; i++) {
            this._renderOverlay(object.children[i], camera);
        }
    }
    _init(configuration) {
        this._overlays = configuration.enableOverlays;
        if (configuration.enableShadows) {
            this.shadowMap.enabled = true;
            this.shadowMap.type = PCFSoftShadowMap; // default PCFShadowMap
        }
        if (configuration.enableVR) {
            this.vr.enabled = true;
            window.addEventListener('vrdisplaypointerrestricted', this._onPointerRestricted.bind(this), false);
            window.addEventListener('vrdisplaypointerunrestricted', this._onPointerUnrestricted.bind(this), false);
            if (!!configuration.initVR) {
                configuration.initVR(this);
            }
        }
    }
    // FIXME element.requestPointerLock does not exists!
    _onPointerRestricted() {
        // const pointerLockElement = this.domElement;
        // if (pointerLockElement && typeof (pointerLockElement.requestPointerLock) === 'function') {
        // pointerLockElement.requestPointerLock();
        // }
    }
    // FIXME element.pointerLockElement does not exists!
    _onPointerUnrestricted() {
        // const currentPointerLockElement = document.pointerLockElement;
        // const expectedPointerLockElement = this.domElement;
        // if (currentPointerLockElement && currentPointerLockElement === expectedPointerLockElement && typeof (document.exitPointerLock) === 'function') {
        // document.exitPointerLock();
        // }
    }
}
//# sourceMappingURL=Renderer.js.map